import { Action } from '@ngrx/store';
import {DevicesInfoData, DevicesStatus, UserDevicesInfo} from '../../models/devices';

// define action types
export const enum DevicesInfoTypes {
  GET_DEVICE_INFO = '[User Devices] GET_DEVICE_INFO',
  GET_DEVICE_INFO_SUCCESS = '[User Devices] GET_DEVICE_INFO_SUCCESS',
  GET_DEVICE_INFO_FAIL = '[User Devices] GET_DEVICE_INFO_FAIL',
  UPDATE_DEVICE_INFO = '[User Deivces] UPDATE_DEVICE_INFO',
  UPDATE_DEVICE_INFO_SUCCESS = '[User Deivces] UPDATE_DEVICE_INFO_SUCCESS',
  UPDATE_DEVICE_INFO_FAIL = '[User Deivces] UPDATE_DEVICE_INFO_FAIL',
  CLEAR_DEVICE_INFO = '[User Devices] CLEAR_DEVICE_INFO'
}


// define Actions class
export class GetDeviceInfoAction implements Action {
  readonly type = DevicesInfoTypes.GET_DEVICE_INFO;
  constructor(public payload: any = null) {}
}
export class GetDeviceInfoSuccessAction implements Action {
  readonly type = DevicesInfoTypes.GET_DEVICE_INFO_SUCCESS;
  constructor(public payload: UserDevicesInfo[] = null) {}
}
export class GetDeviceInfoFailAction implements Action {
  readonly type = DevicesInfoTypes.GET_DEVICE_INFO_FAIL;
  constructor(public payload: any = null) {}
}
export class UpdateDeviceInfoAction implements Action {
  readonly type = DevicesInfoTypes.UPDATE_DEVICE_INFO;
  constructor(public payload: DevicesInfoData = null) {}
}
export class UpdateDeviceInfoSuccessAction implements Action {
  readonly type = DevicesInfoTypes.UPDATE_DEVICE_INFO_SUCCESS;
  constructor(public payload: DevicesInfoData = null) {}
}
export class UpdateDeviceInfoFailAction implements Action {
  readonly type = DevicesInfoTypes.UPDATE_DEVICE_INFO_FAIL;
  constructor(public payload: any = null) {}
}
export class ClearDeviceInfoAction implements Action {
  readonly type = DevicesInfoTypes.CLEAR_DEVICE_INFO;
  constructor(public payload: any = null) {}
}


export type DevicesInfoActions
  = GetDeviceInfoAction
  | GetDeviceInfoSuccessAction
  | GetDeviceInfoFailAction
  | UpdateDeviceInfoAction
  | UpdateDeviceInfoSuccessAction
  | UpdateDeviceInfoFailAction
  | ClearDeviceInfoAction;

